import { render, staticRenderFns } from "./HomePageVisaSection.vue?vue&type=template&id=36447b36&lang=pug"
import script from "./HomePageVisaSection.vue?vue&type=script&lang=ts"
export * from "./HomePageVisaSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports